import { TaxFormKeys } from '@/modules/taxForms/constants'
import { ItemDetail } from '@/modules/taxForms/reports/euer/euerTypes'
import { TaxFormServices } from '@/modules/taxForms/taxFormServices'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppStateType } from '..'

export type State = {
  items: ItemDetail[];
  showEmptyCategories: boolean;
  selectedFieldName: string;
  selectedBookingRowId: string; // bookkeepingAccountingRecord rowId
  availableYears: number[];
  expandAction: { open: boolean; close: boolean };
}

const initialState: State = {
  items: [],
  showEmptyCategories: false,
  selectedFieldName: null,
  selectedBookingRowId: null,
  availableYears: [],
  expandAction: { open: false, close: false },
}

const general = createSlice({
  name: 'taxForms/euer',
  initialState,
  reducers: {
    setShowEmptyCategories: (state, action: PayloadAction<boolean>) => {
      state.showEmptyCategories = action.payload
    },
    setSelectedFieldName: (state, action: PayloadAction<string>) => {
      state.selectedFieldName = action.payload
    },
    setSelectedBookingRowId: (state, action: PayloadAction<string>) => {
      state.selectedBookingRowId = action.payload
    },
    expandAllCategories: (state) => {
      state.expandAction = { open: true, close: false }
    },
    closeAllCategories: (state) => {
      state.expandAction = { open: false, close: true }
    },
    setAvailableYears: (state, action: PayloadAction<number[]>) => {
      state.availableYears = action.payload
    },
  },
})

export default general.reducer

export const { setSelectedFieldName, setShowEmptyCategories, setSelectedBookingRowId, expandAllCategories, closeAllCategories,
  setAvailableYears,
} = general.actions

export const fetchAvailableYears = () => async (dispatch, getState: () => AppStateType) => {
  const state = getState()
  const currentAvailableYears = state.taxForms.euer.availableYears
  if (currentAvailableYears.length > 0) {
    return currentAvailableYears
  }

  const availableYears = await TaxFormServices.getAvailableYears(TaxFormKeys.euer)
  await dispatch(setAvailableYears(availableYears))
  return availableYears
}
